import type { ReactElement } from 'react';
import React, { useEffect, useMemo, useRef } from 'react';
import type { Column } from 'react-table';
import { v4 as uuid } from 'uuid';
import type { TableDatum } from 'atom-components/table-outdated/table';

export default function IndeterminateCheckbox({ indeterminate, id, ...rest }): ReactElement {
  const ref = useRef();
  useEffect(() => {
    const { current = null } = ref;
    if (current) {
      current.indeterminate = indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <div className="form-check">
      <label className="form-check-label" htmlFor={id} aria-hidden>
        <input type="checkbox" className="form-check-input" id={id} ref={ref} {...rest} />
      </label>
    </div>
  );
}

export const useRowSelectColumn = (canSelect: boolean): Column<TableDatum>[] => {
  const column = useMemo(
    () =>
      canSelect
        ? [
            {
              id: 'selection',
              Header: ({ getToggleAllRowsSelectedProps }) => (
                <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} id={uuid()} />
              ),
              Cell: ({ row }) => (
                <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} id={row.id} />
              ),
              width: 20,
              className: 'p-0 px-1',
              headingClassName: 'h-100',
              cellClassName: 'd-flex align-items-center'
            }
          ]
        : [],
    [canSelect]
  );

  return column;
};
